{
  "de": {
    "task_assignment": {
      "actions": {
        "add_assignee": "Verantwortliche Person hinzufügen",
        "bulk_remove": "Aus Aufgabe entfernen",
        "confirm": "Als erledigt markieren",
        "create": "Aufgabe",
        "delete": "Verantwortliche Person entfernen",
        "document_add": "Datei hinzufügen",
        "document_delete": "Löschen",
        "due_in_month": "In einem Monat",
        "due_in_two_weeks": "In zwei Wochen",
        "due_in_week": "In einer Woche",
        "due_remove": "Frist entfernen",
        "open": "Öffnen",
        "reopen": "Erneut öffnen",
        "selectAll": "Alle {total} auswählen",
        "send_and_notify": "Senden und benachrichtigen",
        "set_due_date": "Frist setzen",
        "set_status": "Status setzen",
        "unSelectAll": "Auswahl aufheben",
        "upload_files": "{count} Datei hochladen | {count} Dateien hochladen"
      },
      "assignee_scopes": {
        "external": "Extern",
        "internal": "Intern"
      },
      "assignee_types": {
        "customer": "Kunde",
        "employee": "Teammitglied",
        "partner": "Partner"
      },
      "attributes": {
        "assignee": "Verantwortlich",
        "assignees": "Verantwortliche",
        "comment": "Kommentar",
        "created_at": "Erstellt",
        "document": "Dokument",
        "due_date": "Frist",
        "project": "Projekt",
        "status": "Status",
        "task": "Aufgabe",
        "unit": "Einheit"
      },
      "confirm": {
        "assignees_count": "{count} verantwortliche Person | {count} verantwortliche Personen",
        "bulk_delete_accept": "Entfernen",
        "bulk_delete_body": "Das entfernt ihre Aufgabe für diese Einheiten. Die Aufgabe selbst und die anderen verantwortlichen Personen behalten ihre.",
        "bulk_delete_body_project": "Das entfernt ihre Aufgabe. Die Aufgabe selbst und die anderen verantwortlichen Personen behalten ihre.",
        "bulk_delete_header": "{count} verantwortliche Person entfernen? | {count} verantwortliche Personen entfernen?",
        "complete_accept": "Alles erledigen",
        "complete_body": "Das setzt {assignees} auf {status}, auch die Aufgaben, die der Kunde selbst noch nicht erledigt hat. In ihrer Liste wandern sie zu den erledigten Aufgaben.",
        "complete_header": "Alles auf erledigt setzen?",
        "customer_tasks": "{count} Kundenaufgabe | {count} Kundenaufgaben",
        "customers_and_team": "{customers} und {team}",
        "delete_body": "Das entfernt ihre Aufgabe für diese Einheit. Andere Einheiten und verantwortliche Personen behalten ihre.",
        "delete_body_project": "Das entfernt ihre Aufgabe. Andere verantwortliche Personen behalten ihre.",
        "delete_header": "{name} aus {unit} entfernen?",
        "delete_header_project": "{name} aus dieser Aufgabe entfernen?",
        "delete_sent_customers": "Diese wurde bereits versendet, sie verschwindet also auch aus dem Portal der Kunden.",
        "delete_sent_team": "Diese wurde bereits versendet, sie verschwindet also auch aus der Liste von {name}.",
        "document_delete_body": "Die Datei verschwindet auch aus den Dokumenten der Einheit.",
        "document_delete_body_project": "Die Datei verschwindet auch aus den Dokumenten des Projekts.",
        "document_delete_header": "Diese Datei löschen?",
        "draft_accept": "Alles auf Entwurf setzen",
        "draft_body": "Das setzt {assignees} zurück auf {status}. Die Aufgabe verschwindet aus der Liste des Kunden, bis du sie erneut sendest. Bereits verschickte E-Mails bleiben verschickt.",
        "draft_header": "Alles zurück auf Entwurf?",
        "send_body": "Das setzt {who} auf {status}.",
        "send_customers": "Kunden sehen die Aufgabe sofort in ihrem Portal und bekommen eine E-Mail dazu.",
        "send_header": "Diese Aufgabe senden? | Diese Aufgaben senden?",
        "send_permanent": "Du kannst sie später wieder auf Entwurf setzen, aber die Benachrichtigung ist dann schon verschickt.",
        "send_team": "Teammitglieder sehen die Aufgabe auf ihrem Dashboard und werden benachrichtigt.",
        "tasks_count": "{count} Aufgabe | {count} Aufgaben",
        "team_tasks": "{count} Teamaufgabe | {count} Teamaufgaben"
      },
      "deep_link": {
        "completed": "Diese Aufgabe ist bereits erledigt.",
        "gone": "Diese Aufgabe ist nicht mehr offen."
      },
      "empty": {
        "filtered_description": "Passe deine Filter an oder lösche sie, um alle Zuweisungen zu sehen.",
        "filtered_title": "Keine Zuweisungen passen zu deinen Filtern",
        "none_title": "Keine Zuweisungen"
      },
      "filters": {
        "assignee_any": "Alle Verantwortlichen",
        "clear_all": "Alle Filter leeren",
        "done": "Fertig",
        "due_window_values": {
          "none": "Keine Frist",
          "overdue": "Überfällig",
          "set": "Hat eine Frist"
        },
        "phase_any": "Alle Phasen",
        "show_only": "Nur anzeigen",
        "show_only_values": {
          "customers": "Kunden",
          "mine": "Mir zugewiesen",
          "team": "Team"
        },
        "unit_any": "Alle Einheiten"
      },
      "labels": {
        "add_assignee": "Verantwortliche Person hinzufügen",
        "add_customers": "Kunden hinzufügen",
        "already_assigned": "Diese Aufgabe wurde dieser Einheit bereits hinzugefügt.",
        "already_assigned_project": "Diese Aufgabe wurde diesem Projekt bereits hinzugefügt.",
        "assignees": "Zugewiesene",
        "assignees_subtitle": "Jeder erhält eine eigene Aufgabe, pro Einheit.",
        "assignees_title": "Wer soll es tun",
        "comment_earlier_round": "frühere Runde",
        "comment_placeholder": "z. B. der Zähler war schwer zu erreichen, das ist das beste Foto, das ich machen konnte",
        "comments_none": "Der Kunde hat keinen Kommentar hinterlassen.",
        "comments_title": "Kommentare zu dieser Aufgabe",
        "completed": "Erledigt",
        "confirm_message": "Möchten Sie diese Aufgabe wirklich als erledigt markieren?",
        "customers": "Kunden",
        "documents_none": "Noch nichts hochgeladen.",
        "documents_title": "Dateien zu dieser Aufgabe",
        "earlier": "+{count} früher",
        "my_tasks": "Meine Aufgaben",
        "no_assignees": "Noch keine Verantwortlichen.",
        "no_assignments": "Aufgaben, die dir zugewiesen werden, erscheinen hier.",
        "no_assignments_task": "Noch keine Zuweisungen für diese Aufgabe.",
        "previous_upload": "früherer Upload",
        "required": "Dieses Feld ist erforderlich",
        "selectOne": "Wählen Sie mindestens eine Aufgabe.",
        "select_task": "Aufgabe auswählen",
        "selected": "{selected} ausgewählt | {selected} ausgewählt",
        "set_status_for": "Status setzen für {name}",
        "status_hint_assignees": "die zugewiesene Person | die zugewiesenen Personen",
        "status_hint_customer": "den Kunden",
        "status_hint_sent": "die Personen, an die sie gesendet wurde",
        "superseded": "ersetzt",
        "totalSelected": "Alle {total} ausgewählt",
        "upload_hint": "Laden Sie die angeforderten Dokumente hoch, um diese Aufgabe zu erledigen."
      },
      "status_hints": {
        "completed": "Die Aufgabe ist erledigt. Sie bleibt für {who} sichtbar, unter {completed}.",
        "draft": "Noch nicht sichtbar für {who}. Setze die Aufgabe auf {open}, um sie zu teilen.",
        "requested": "Sichtbar für {who}. Die Aufgabe muss noch erledigt werden."
      },
      "statuses": {
        "completed": "Erledigt",
        "draft": "Entwurf",
        "requested": "Offen"
      },
      "toasts": {
        "bulk_delete": "Aufgaben entfernt",
        "bulk_update": "Aufgaben aktualisiert",
        "completed": "Aufgabe erledigt",
        "create": "Aufgabe erstellt",
        "delete": "Verantwortliche Person entfernt",
        "document_added": "Datei hinzugefügt",
        "document_deleted": "Datei gelöscht",
        "reopened": "Aufgabe wieder geöffnet",
        "update": "Aufgabe aktualisiert"
      }
    }
  }
}
